import type { EllipsisConfig } from 'antd/es/typography/Base';
import type { TitleProps } from 'antd/es/typography/Title';
import { PropsWithChildren } from 'react';

import { TitleSizes } from './typography.options';
import { StyledParagraph, StyledSmallTitle, StyledText, StyledTitle, StyledTitleProps } from './typography.style';

type TitlePropsType = Omit<TitleProps, 'level'> &
  StyledTitleProps & {
    level?: 1 | 2 | 3 | 4 | 5 | 6;
  };

export interface TextProps extends StyledTitleProps {
  level?: keyof typeof TitleSizes;
  paragraph?: boolean;
  ellipsis?: EllipsisConfig;
}

export const Title = ({ level, ...props }: TitlePropsType) =>
  level === 6 ? <StyledSmallTitle {...props} /> : <StyledTitle level={level} {...props} />;

export const Text = ({ paragraph, ...props }: PropsWithChildren<TextProps>) =>
  paragraph ? <StyledParagraph {...props} /> : <StyledText {...props} />;
